import {Directive, ViewContainerRef, inject} from '@angular/core';

@Directive({
    selector: '[appDynamicDirective]',
    standalone: true
})
export class DynamicDirectiveDirective {

  viewContainerRef = inject(ViewContainerRef);
}
